<template>
  <div class="box">
    <div class="head">
      <div class="headleft">
        <div>易畅网络</div>
      </div>
      <div class="headright">
        <div
          @click="jumpClick1()"
          :class="this.isshow == 1 ? 'headdiv' : 'headdivs'"
        >
          首頁
        </div>
        <div
          @click="jumpClick2()"
          :class="this.isshow == 2 ? 'headdiv' : 'headdivs'"
        >
          产品介绍
        </div>
        <div
          @click="jumpClick3()"
          :class="this.isshow == 3 ? 'headdiv' : 'headdivs'"
        >
          关于我们
        </div>
      </div>
    </div>
    <div id="box1" class="bgbox1">
      <div class="bgbox1title1">易畅网络</div>
      <div class="bgbox1title2">
        易畅网络有限公司位于广西壮族自治区南宁市（广西）自由贸易试验区南宁片区庆林路16号天誉花园4号地块5号楼三层3880号。公司多年致力于以用户为中心打造符合用户使用心理的产品，用数据说话，用心去感受用户。立足互联网，放眼世界，以创新和质量为标准，打造服务用户和广大社会的产品。
      </div>
    </div>
    <div id="box2" class="bgbox2">
      <div class="bgbox2img">
        <img src="../../static/Group48096168.png" alt="" />
      </div>
      <div class="box2box">
        <div class="box2boxleft">
          <div class="lefttop">
            <div class="lefttopimg1"></div>
            <div class="lefttopimg2"></div>
          </div>
          <div class="leftbottom">
            <div class="leftbottomimg1"></div>
            <div class="leftbottomimg2"></div>
          </div>
        </div>
        <div class="box2boxright"></div>
      </div>
      <div class="box2boxs">
        <div class="box2boxsiconwifi"></div>
        <div class="box2boxstitle">WiFi管理大师</div>
        <div class="box2boxstitle2">30万下载 ｜ 45M</div>
        <div class="box2boxstitle3">
          WiFi管理大师是一款好用的网络工具。<br />
          1.安全连接WiFi，尽情畅享网络；<br />
          2.测试网络速度，抢红包不再错过；<br />
          3.网速过卡，检测蹭网看看谁在偷偷蹭网；。<br />
        </div>
        <a
          href="https://twa.toponegames.izkun.com/config/apk/WIFIguanlidashi/official-WIFI%E7%AE%A1%E7%90%86%E5%A4%A7%E5%B8%88-WiFiManageMasterRelease-v2302_d16b7a77.apk"
        >
          <div class="btn">立即下载</div>
        </a>
        <div class="imgonewifi"></div>
        <div class="imgtwowifi"></div>
      </div>
      <div class="box2boxs">
        <div class="box2boxsicon1s"></div>
        <div class="box2boxstitle">龙行计步</div>
        <div class="box2boxstitle2">30万下载 ｜ 30M</div>
        <div class="box2boxstitle3">
          该软件是一款健康管理app，帮助您记录您的走路步数让你更好的管理您的健康！<br />
          <!-- 功能：<br />
          计步器：支持跑步、步行、骑行等多种运动类型，实时监测并记录行走步数、运动轨迹、配速、里程与卡路里等详细数据。<br />
          日常打卡：简易快捷的追踪日常习惯，帮助你轻松打卡，养成和记录良好习惯。<br />
          健康指南：给你带来更多健康饮食建议。 -->
        </div>
        <a
          href="https://twa.toponegames.izkun.com/config/apk/longxingjibu/official-%28%E9%9D%9E%E5%95%86%E5%BA%97%29%E9%BE%99%E8%A1%8C%E8%AE%A1%E6%AD%A5-v2385-DragonStepNotStoreRelease_9120604e.apk"
        >
          <div class="btn">立即下载</div>
        </a>
        <div class="imgone1"></div>
        <div class="imgtwo1"></div>
      </div>
      <div class="box2boxs">
        <div class="box2boxsicon"></div>
        <div class="box2boxstitle">5GWiFi助手</div>
        <div class="box2boxstitle2">30万下载 ｜ 45M</div>
        <div class="box2boxstitle3">
          【一键测速】多方面、全方位、智能化为一体的专业网络测速工具类APP。
          <br />
          【防蹭网】龟速网络慢？一键检测蹭网设备，扫除蹭网设备智能添加至黑名单，告别网络龟速。
        </div>
        <a
          href="https://twa.toponegames.izkun.com/config/privacy/5GWiFi/5GWiFiPravicy.html"
        >
          <div class="btn">立即下载</div>
        </a>
        <div class="imgone"></div>
        <div class="imgtwo"></div>
      </div>
      <div class="box2boxs">
        <div class="box2boxsicon1"></div>
        <div class="box2boxstitle">番茄运动</div>
        <div class="box2boxstitle2">30万下载 ｜ 30M</div>
        <div class="box2boxstitle3">
          番茄运动是进行日常计步和跑步记录的运动计步器软件，专注于健走跑步骑行记录和运动大数据分析，帮助用户提高运动效率，改善健康状态。<br />
          功能：<br />
          计步器：支持跑步、步行、骑行等多种运动类型，实时监测并记录行走步数、运动轨迹、配速、里程与卡路里等详细数据。<br />
          日常打卡：简易快捷的追踪日常习惯，帮助你轻松打卡，养成和记录良好习惯。<br />
          健康指南：给你带来更多健康饮食建议。
        </div>
        <div class="imgone1"></div>
        <div class="imgtwo1"></div>
      </div>
      <div class="box2boxs">
        <div class="box2boxsicon2"></div>
        <div class="box2boxstitle">充电有宝</div>
        <div class="box2boxstitle2">30万下载 ｜ 45M</div>
        <div class="box2boxstitle3">
          充电有宝是一款实用的充电软件，为您提供电池信息展示。您可以轻松查看电池剩余容量、充电状态等信息，让您时刻了解电池的健康状况。
        </div>
        <div class="imgone2"></div>
        <div class="imgtwo2"></div>
      </div>
      <div class="box2boxs">
        <div class="box2boxsicon3"></div>
        <div class="box2boxstitle">随身放大镜</div>
        <div class="box2boxstitle2">30万下载 ｜ 28M</div>
        <div class="box2boxstitle3">
          随身放大镜，每天看字更省心！可以帮你识别近期天气，更有电子日历，是中老年伙伴的百宝箱。
        </div>
        <div class="imgone3"></div>
        <div class="imgtwo3"></div>
      </div>
    </div>
    <div id="box3" class="bgbox3">
      <div class="box3head">
        <img src="../../static/box3head.png" alt="" />
      </div>
      <div class="bigbox3box">
        <div class="box3box">
          <div class="box3left"></div>
          <div class="box3right">
            <div class="box3righttop">
              <div class="box3ringhttop1">
                <div class="title">公司地址</div>
                <div class="content">
                  易畅网络有限公司位于广西壮族自治区南宁市（广西）自由贸易试验区南宁片区庆林路16号天誉花园4号地块5号楼三层3880号
                </div>
                <div class="imge"></div>
              </div>
              <div class="box3ringhttop2">
                <div class="title">联系我们</div>
                <div class="content">林小姐：<br />lindanhua@heartjoy.com</div>
                <div class="contents">
                  陈小姐：<br />
                  hr@heartjoy.com
                </div>
                <div class="imge"></div>
              </div>
            </div>
            <div class="box3rightbottom">
              <div class="title">加入我们</div>
              <div class="content">
                我们提供一流的就业待遇和发展空间,期待您的加入!
              </div>
              <div class="imge"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bgbox4">
      <div>·公司地址：易畅网络有限公司位于广西壮族自治区南宁市</div>
      <div>
        （广西）自由贸易试验区南宁片区庆林路16号天誉花园4号地块5号楼三层3880号
      </div>
      <div>
        <a
          style="color: #ffffff"
          target="_blank"
          href="https://beian.miit.gov.cn/"
          >·备案号：桂ICP备2022008935号-1</a
        >
        <a
          style="color: #ffffff"
          href="../../static/广西易畅文网文正本.jpg"
          target="_blank"
          >·编号：桂网文 (2023) 0996-275号
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      isshow: 1,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    getScroll() {
      return {
        left:
          window.pageXOffset ||
          document.documentElement.scrollLeft ||
          document.body.scrollLeft ||
          0,
        top:
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          0,
      };
    },
    handleScroll() {
      const scrollTop = this.getScroll().top;
      //获取盒子高度
      if (scrollTop >= 1080 && scrollTop <= 2160) {
        this.isshow = 2;
      } else if (scrollTop >= 2160) {
        this.isshow = 3;
      } else {
        this.isshow = 1;
      }
    },
    jumpClick1() {
      this.isshow = 1;
      document.querySelector("#box1").scrollIntoView(true);
    },
    jumpClick2() {
      this.isshow = 2;
      document.querySelector("#box2").scrollIntoView(true);
    },
    jumpClick3() {
      this.isshow = 3;
      document.querySelector("#box3").scrollIntoView(true);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  text-decoration: none;
}
.box {
  min-width: 1900px;
}
.bgbox1 {
  width: 100%;
  height: 1080px;
  background-image: url("../../static/bg-001.png");
  background-size: 100% 100%;
}
.bgbox1title1 {
  width: 672px;
  height: 101px;
  padding-top: 410px;
  padding-left: 238px;
  font-family: DingTalk JinBuTi;
  font-size: 84px;
  font-style: italic;
  font-weight: 400;
  line-height: 101px;
  letter-spacing: 0em;
  color: #ffffff;
  text-align: left;
}
.bgbox1title2 {
  width: 672px;
  height: 101px;
  padding-left: 238px;
  font-family: PingFang SC;
  font-size: 20px;
  font-weight: 400;
  line-height: 40px;
  letter-spacing: 0em;
  text-align: left;
  color: #ffffff;
  opacity: 0.8;
}

.bgbox2 {
  width: 100%;
  background: #131821;
}
.bgbox2img {
  padding-top: 82px;
  margin-bottom: 57px;
  text-align: center;
}
.bgbox2img img {
  display: inline-block;
  width: 281px;
  height: 65px;
}
.box2box {
  margin-left: 12.7%;
  width: 75%;
  height: 677px;
  display: flex;
  padding-bottom: 40px;
}
.box2boxleft {
  width: 66.6%;
  height: 677px;
}
.box2boxright {
  width: 33.33%;
  height: 677px;
  background-image: url("../../static/card-003.png");
  background-size: 100% 100%;
}
.lefttop {
  display: flex;
}
.lefttopimg1 {
  width: 38%;
  height: 360px;
  background-image: url("../../static/card-001.png");
  background-size: 100% 100%;
}
.lefttopimg2 {
  margin-left: 40px;
  width: 54%;
  height: 360px;
  background-image: url("../../static/card-002.png");
  background-size: 100% 100%;
}
.leftbottom {
  display: flex;
  margin-top: 40px;
}
.leftbottomimg1 {
  width: 58%;
  height: 277px;
  background-image: url("../../static/card-004.png");
  background-size: 100% 100%;
}
.leftbottomimg2 {
  margin-left: 40px;
  width: 34%;
  height: 277px;
  background-image: url("../../static/card-005.png");
  background-size: 100% 100%;
}
.box2boxs {
  position: relative;
  display: inline-block;
  width: 75%;
  height: 720px;
  background-image: url("../../static/2.png");
  background-size: 100% 100%;
  margin-left: 12.5%;
  margin-bottom: 51px;
  overflow: hidden;
}
.box2boxsicon {
  margin-top: 130px;
  margin-left: 120px;
  width: 132px;
  height: 132px;
  background-image: url("../../static/icon_fillet_1024.png");
  background-size: 100% 100%;
}
.box2boxstitle {
  margin-top: 18px;
  margin-left: 120px;
  color: #fff;
  font-size: 48px;
  font-family: DingTalk JinBuTi;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.box2boxstitle2 {
  margin-top: 18px;
  margin-left: 120px;
  color: #fff;
  font-size: 14px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  opacity: 0.5;
}
.box2boxstitle3 {
  margin-top: 18px;
  margin-left: 120px;
  width: 540px;
  color: #fff;
  font-size: 20px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
.btn {
  margin-top: 48px;
  margin-left: 120px;
  width: 168px;
  height: 69px;
  border-radius: 12px;
  background: #fff;
  color: #000;
  font-size: 30px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 600;
  line-height: 69px;
  text-align: center;
}
.imgone {
  position: absolute;
  top: 137px;
  left: 59.6%;
  width: 17%;
  height: 445.708px;
  flex-shrink: 0;
  border-radius: 27.4px;
  border: 2px solid rgba(255, 182, 182, 0.87);
  background: url(<path-to-image>), lightgray 50% / cover no-repeat;
  background-image: url("../../static/WiFi助手_001.png");
  background-size: 100% 100%;
}
a {
  text-decoration: none;
}
.imgtwo {
  position: absolute;
  top: 340px;
  left: 79.4%;
  width: 17%;
  height: 445.708px;
  flex-shrink: 0;
  border-radius: 27.4px;
  border: 2px solid rgba(255, 182, 182, 0.87);
  background: url(<path-to-image>), lightgray 50% / cover no-repeat;
  background-image: url("../../static/WiFi助手_002.png");
  background-size: 100% 100%;
}
.box2boxsicon1 {
  margin-top: 130px;
  margin-left: 120px;
  width: 132px;
  height: 132px;
  background-image: url("../../static/番茄运动官网/ic_512.png");
  background-size: 100% 100%;
}
.box2boxsicon1s {
  margin-top: 130px;
  margin-left: 120px;
  width: 132px;
  height: 132px;
  background-image: url("../../static/龙行计步/image.png");
  background-size: 100% 100%;
}
.box2boxsiconwifi {
  margin-top: 130px;
  margin-left: 120px;
  width: 132px;
  height: 132px;
  background-image: url("../../static/wifi管理大师/ic_512_fiilet.png");
  background-size: 100% 100%;
}
.imgone1 {
  position: absolute;
  top: 137px;
  left: 59.6%;
  width: 17%;
  height: 445.708px;
  flex-shrink: 0;
  border-radius: 27.4px;
  border: 2px solid rgba(255, 182, 182, 0.87);
  background: url(<path-to-image>), lightgray 50% / cover no-repeat;
  background-image: url("../../static/龙行计步/image1.png");
  background-size: 100% 100%;
}
.imgtwo1 {
  position: absolute;
  top: 340px;
  left: 79.4%;
  width: 17%;
  height: 445.708px;
  flex-shrink: 0;
  border-radius: 27.4px;
  border: 2px solid rgba(255, 182, 182, 0.87);
  background: url(<path-to-image>), lightgray 50% / cover no-repeat;
  background-image: url("../../static/龙行计步/image2.png");
  background-size: 100% 100%;
}
.imgonewifi {
  position: absolute;
  top: 137px;
  left: 59.6%;
  width: 17%;
  height: 445.708px;
  flex-shrink: 0;
  border-radius: 27.4px;
  border: 2px solid rgba(255, 182, 182, 0.87);
  background: url(<path-to-image>), lightgray 50% / cover no-repeat;
  background-image: url("../../static/wifi管理大师/001.png");
  background-size: 100% 100%;
}
.imgtwowifi {
  position: absolute;
  top: 340px;
  left: 79.4%;
  width: 17%;
  height: 445.708px;
  flex-shrink: 0;
  border-radius: 27.4px;
  border: 2px solid rgba(255, 182, 182, 0.87);
  background: url(<path-to-image>), lightgray 50% / cover no-repeat;
  background-image: url("../../static/wifi管理大师/img_startpage.9.png");
  background-size: 100% 100%;
}
.box2boxsicon2 {
  margin-top: 130px;
  margin-left: 120px;
  width: 132px;
  height: 132px;
  background-image: url("../../static/充电有宝官网/ic_168.png");
  background-size: 100% 100%;
}
.imgone2 {
  position: absolute;
  top: 137px;
  left: 59.6%;
  width: 17%;
  height: 445.708px;
  flex-shrink: 0;
  border-radius: 27.4px;
  border: 2px solid rgba(255, 182, 182, 0.87);
  background: url(<path-to-image>), lightgray 50% / cover no-repeat;
  background-image: url("../../static/充电有宝官网/001.png");
  background-size: 100% 100%;
}
.imgtwo2 {
  position: absolute;
  top: 340px;
  left: 79.4%;
  width: 17%;
  height: 445.708px;
  flex-shrink: 0;
  border-radius: 27.4px;
  border: 2px solid rgba(255, 182, 182, 0.87);
  background: url(<path-to-image>), lightgray 50% / cover no-repeat;
  background-image: url("../../static/充电有宝官网/002.png");
  background-size: 100% 100%;
}
.box2boxsicon3 {
  margin-top: 130px;
  margin-left: 120px;
  width: 132px;
  height: 132px;
  background-image: url("../../static/随身放大镜官网/ic_168.png");
  background-size: 100% 100%;
}
.imgone3 {
  position: absolute;
  top: 137px;
  left: 59.6%;
  width: 17%;
  height: 445.708px;
  flex-shrink: 0;
  border-radius: 27.4px;
  border: 2px solid rgba(255, 182, 182, 0.87);
  background: url(<path-to-image>), lightgray 50% / cover no-repeat;
  background-image: url("../../static/随身放大镜官网/001.png");
  background-size: 100% 100%;
}
.imgtwo3 {
  position: absolute;
  top: 340px;
  left: 79.4%;
  width: 17%;
  height: 445.708px;
  flex-shrink: 0;
  border-radius: 27.4px;
  border: 2px solid rgba(255, 182, 182, 0.87);
  background: url(<path-to-image>), lightgray 50% / cover no-repeat;
  background-image: url("../../static/随身放大镜官网/002.png");
  background-size: 100% 100%;
}

.bgbox3 {
  width: 100%;
  height: 1080px;
}
.box3head {
  margin-top: 80px;
  margin-bottom: 52px;
  text-align: center;
}
.box3head img {
  width: 281px;
  height: 65px;
  display: inline-block;
}
.bigbox3box {
  text-align: center;
}
.box3box {
  margin-left: 50%;
  transform: translate(-50%, 0);
  width: 1800px;
  height: 935px;
  display: flex;
}
.box3left {
  display: inline-block;
  width: 540px;
  height: 684px;
  background-image: url("../../static/img_map.png");
  background-size: 100% 100%;
  margin-left: 240px;
  margin-right: 40px;
}
.box3righttop {
  display: flex;
}
.box3ringhttop1 {
  width: 410px;
  height: 345px;
  background-color: #131821;
  border-radius: 20px;
  position: relative;
}
.box3ringhttop2 {
  margin-left: 40px;
  width: 410px;
  height: 345px;
  background-color: #131821;
  border-radius: 20px;
  position: relative;
}
.title {
  font-family: Fira Sans;
  font-size: 24px;
  font-weight: 800;
  line-height: 29px;
  letter-spacing: 0em;
  text-align: left;
  color: #ffffff;
  padding-top: 36px;
  padding-left: 24px;
  padding-bottom: 36px;
}
.content {
  font-family: PingFang SC;
  font-size: 20px;
  font-weight: 400;
  line-height: 40px;
  letter-spacing: 0em;
  text-align: left;
  padding-left: 24px;
  padding-right: 16px;
  color: #ffffff;
  opacity: 0.8;
}
.contents {
  margin-top: 22px;
  font-family: PingFang SC;
  font-size: 20px;
  font-weight: 400;
  line-height: 40px;
  letter-spacing: 0em;
  text-align: left;
  padding-left: 24px;
  padding-right: 16px;
  color: #ffffff;
  opacity: 0.8;
}
.imge {
  width: 136px;
  height: 102px;
  background-image: url("../../static/ic_location.png");
  background-size: 100% 100%;
  position: absolute;
  bottom: -24px;
  right: -20px;
}
.box3rightbottom {
  display: inline-block;
  width: 410px;
  height: 298px;
  background-color: #131821;
  border-radius: 20px;
  position: relative;
  margin-top: 40px;
  margin-left: -50%;
}

.bgbox4 {
  width: 100%;
  height: 160px;
  background-image: url("../../static/bg-002-ending.png");
  background-size: 100% 100%;
  padding-top: 40px;
}
.bgbox4 div {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 400;
  line-height: 40px;
  letter-spacing: 0em;
  text-align: center;
  color: #ffffff;
}

.head {
  width: 100%;
  height: 100px;
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  background: rgba(95, 93, 93, 0.5);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
.headleft {
  width: 50%;
  height: 100px;
}
.headleft div {
  margin-top: 0px;
  margin-left: 120px;
  width: 258px;
  height: 58px;
  background-size: 100% 100%;
  font-family: DingTalk JinBuTi;
  font-size: 44px;
  font-style: italic;
  font-weight: 400;
  line-height: 101px;
  letter-spacing: 0em;
  color: #ffffff;
  text-align: left;
}
.headright {
  display: flex;
  padding-left: 126px;
}
.headdiv {
  margin-left: 58px;
  width: 128px;
  height: 60px;
  margin-top: 20px;
  border-radius: 120px;
  background-color: #ffffff;
  font-family: PingFang SC;
  font-size: 24px;
  font-weight: 400;
  line-height: 60px;
  letter-spacing: 0em;
  text-align: center;
  cursor: pointer;
}
.headdivs {
  margin-left: 58px;
  width: 128px;
  height: 60px;
  margin-top: 20px;
  border-radius: 120px;
  font-family: PingFang SC;
  font-size: 24px;
  font-weight: 400;
  line-height: 60px;
  letter-spacing: 0em;
  color: #ffffff;
  text-align: center;
  cursor: pointer;
  background: #ffffff33;
}
</style>


// WEBPACK FOOTER //
// src/components/HelloWorld.vue